export const api = {
  namespace: "app",
  getters: {
    jsonExport: "jsonExport",
    sitemap: "sitemap",
    getStatus: "getStatus",
    getMessageline: "getMessageline",
    getCurrentLanguage: "getCurrentLanguage",
    isLoading: "isLoading",
    getIsOnline: "getIsOnline"
  },
  mutations: {
    resetState: "resetState",
    setLoading: "setLoading",
    setStatus: "setStatus",
    toggleDrawer: "toggleDrawer",
    toggleDrawerRight: "toggleDrawerRight",
    setDrawerRight: "setDrawerRight",
    addStatus: "addStatus",
    shiftStatus: "shiftStatus",
    setLanguage: "setLanguage",
    SET_IS_ONLINE: "SET_IS_ONLINE"
  },
  actions: {
    reloadApp: "reloadApp",
    setLoading: "setLoading",
    setStatus: "setStatus",
    toggleDrawer: "toggleDrawer",
    toggleDrawerRight: "toggleDrawerRight",
    setDrawerRight: "setDrawerRight",
    addStatus: "addStatus",
    shiftStatus: "shiftStatus",
    setLanguage: "setLanguage",
    setIsOnline: "setIsOnline"
  },
  state: {
    drawerVisible: "drawerVisible",
    drawerRightVisible: "drawerRightVisible",
    drawerRight: "drawerRight",
    isLoading: "isLoading",
    status: "status",
    messageline: "messageline",
    language: "language",
    isOnline: "isOnline"
  }
};

const defaultState = () => {
  return {
    [api.state.appTitle]: "Audit Cloud",
    [api.state.isLoading]: false,
    [api.state.status]: false,
    [api.state.messageline]: [],
    [api.state.drawerVisible]: false,
    [api.state.drawerRightVisible]: false,
    [api.state.drawerRight]: {},
    [api.state.language]: (() => {
      let lang = (window.navigator.language || "de").substring(0, 2);
      if (!/^(de|en)$/.test(lang)) {
        lang = "en";
      }
      return lang;
    })(),
    [api.state.isOnline]: window.navigator.onLine
  };
};

const state = defaultState();

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.toggleDrawer](state, drawerVisible) {
    if (drawerVisible == null) {
      drawerVisible = !state.drawerVisible;
    }
    state.drawerVisible = drawerVisible;
  },
  [api.mutations.toggleDrawerRight](state, drawerRightVisible) {
    if (drawerRightVisible == null) {
      drawerRightVisible = !state.drawerRightVisible;
    }
    state.drawerRightVisible = drawerRightVisible;
  },
  [api.mutations.setLoading](state, payload) {
    state.isLoading = payload;
  },
  [api.mutations.setStatus](state, payload) {
    state.status = payload;
  },
  [api.mutations.setDrawerRight](state, payload) {
    state.drawerRight = payload;
  },
  [api.mutations.addStatus](state, payload) {
    return state.messageline.push(payload);
  },

  [api.mutations.shiftStatus](state) {
    return state.messageline.shift();
  },
  [api.mutations.setLanguage](state, payload) {
    state.language = payload;
  },
  [api.mutations.SET_IS_ONLINE](state, payload) {
    state.isOnline = payload;
  }
};

const actions = {
  [api.actions.reloadApp]({ dispatch }) {
    console.log("Reload app");
    dispatch("configuration/loadData", false, { root: true });
    dispatch("users/loadUsers", false, { root: true });
    dispatch("users/loadRoles", false, { root: true });
    dispatch("standards/loadStandards", false, { root: true });
    dispatch("templates/loadAudits", false, { root: true });
    // TODO: Wie kann man hier den Nutzer reinbekommen?
    //dispatch("activities/loadActivities", this.$user.id(), { root: true });
  },
  [api.actions.setLoading]({ commit }, payload) {
    commit("setLoading", payload);
  },
  [api.actions.setStatus]({ commit }, payload) {
    commit("setStatus", payload);
  },
  [api.actions.toggleDrawer]({ commit }, payload) {
    commit("toggleDrawer", payload);
  },
  [api.actions.toggleDrawerRight]({ commit }, payload) {
    commit("toggleDrawerRight", payload);
  },
  [api.actions.setDrawerRight]({ commit }, payload) {
    commit("setDrawerRight", payload);
  },
  [api.actions.addStatus]({ commit }, payload) {
    commit("addStatus", payload);
  },
  [api.actions.shiftStatus]({ commit }) {
    commit("shiftStatus");
  },
  [api.actions.setLanguage]({ commit }, payload) {
    commit("setLanguage", payload);
  },

  [api.actions.setIsOnline]({ commit }, payload) {
    console.log("ONLINE_STATE:ACTION", state.isOnline, payload);
    commit(api.mutations.SET_IS_ONLINE, payload);
  }
};

const getters = {
  [api.getters.getStatus](state) {
    return state.status;
  },
  [api.getters.getMessageline](state) {
    return state.messageline;
  },
  [api.getters.isLoading](state) {
    return state.isLoading;
  },
  [api.getters.jsonExport](state, getters, rootState) {
    return JSON.stringify(
      {
        state: rootState
      },
      null,
      2
    );
  },
  [api.getters.sitemap]() {
    return [
      { icon: "home", text: "Dashboard", route: "/" },
      {
        icon: "watch_later",
        text: "Standards und Normen",
        route: "/standards"
      },
      {
        icon: "featured_play_list",
        text: "Vorlagen und Fragenpool",
        route: "/templates"
      },
      //{ icon: "subscriptions", text: "Audit Serien", route: "/auditseries" },
      { icon: "subscriptions", text: "Audit Programm", route: "/auditmatrix" },
      { icon: "history", text: "Maßnahmen", route: "/measures" }
      //{ icon: "watch_later", text: "Archiv", route: "/archive" }
    ];
  },
  [api.getters.getCurrentLanguage](state) {
    return state.language;
  },
  [api.getters.getIsOnline](state) {
    console.log("ONLINE_STATE:GETTER", state.isOnline);
    return state.isOnline;
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
